import type { McpServerCreateRequest } from "../types";

export function sanitizeGatewayPayload(
  values: McpServerCreateRequest
): McpServerCreateRequest {
  if (values.auth_type !== "arcade_header") {
    return values;
  }

  const { consent_skip_client_ids: _stripped, ...rest } = values;
  return rest;
}
